import * as React from 'react'
import type { SVGProps } from 'react'
import PropTypes from 'prop-types'

/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number
  alt?: string
}
function IconVolumeOffDefault(
  { srText, size = 'md', className = '', ...props }: Props,
) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={24}
        height={25}
        fill='none'
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M11.418 4.581c.355.145.582.46.582.808V19.61c0 .347-.227.663-.582.808a1.1 1.1 0 0 1-1.069-.133L6.63 17.452H3c-.552 0-1-.398-1-.889V8.438c0-.491.448-.89 1-.89h3.63l3.72-2.833a1.1 1.1 0 0 1 1.068-.133M10 7.321l-2.35 1.79a1.08 1.08 0 0 1-.65.214H4v6.35h3c.239 0 .47.075.65.214l2.35 1.79zM15.293 9.651a1.09 1.09 0 0 1 1.414 0l1.793 1.594 1.793-1.594a1.09 1.09 0 0 1 1.414 0 .82.82 0 0 1 0 1.257l-1.793 1.594 1.793 1.593a.82.82 0 0 1 0 1.257 1.09 1.09 0 0 1-1.414 0L18.5 13.76l-1.793 1.593a1.09 1.09 0 0 1-1.414 0 .82.82 0 0 1 0-1.257l1.793-1.593-1.793-1.594a.82.82 0 0 1 0-1.257'
          clipRule='evenodd'
        />
      </svg>
    </>
  )
}
IconVolumeOffDefault.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>
export default IconVolumeOffDefault
